// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"b5eaf805","50":"0af7b8de","244":"0af7b8de","379":"ee456517","421":"9d739cc7","811":"25a61a2c","865":"ee456517","938":"ee456517"}[chunkId] + ".chunk.css";
};